/**
 * Use the CSS tab above to style your Element's container.
 */
import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import styles from './css/CardSection.scss';
import FormLabel from '@mui/material/FormLabel';
import { useTheme } from '@mui/material/styles';
import { Box, FormControl } from '@mui/material';

const get_CARD_ELEMENT_OPTIONS = isDark => ({
	iconStyle: 'solid',
	hidePostalCode: true,
	style: {
		base: {
			color: isDark ? '#fff' : '#000',
			iconColor: '#177cce',
			fontWeight: 500,
			fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
			fontSize: '16px',
			fontSmoothing: 'antialiased',
			':-webkit-autofill': { color: '#fce883' },
			'::placeholder': { color: '#87bbfd' },
			fieldset: { backgroundColor: 'red' }
		},
		invalid: {
			iconColor: '#ff0000',
			color: '#ff0000'
		}
	}
});

const CardField = () => {
	const { palette } = useTheme();
	const isDark = palette.mode === 'dark';
	const frameColor = isDark ? 'rgba(255, 255, 255,.23)' : 'rgba(0,0,0,.23)';
	const frameColorFull = isDark ? 'rgb(255, 255, 255)' : 'rgb(0,0,0)';
	const frameColorHilite = palette.primary.main;

	return (
		<fieldset className={styles.FormGroup}>
			<div
				className={styles.FormRow}
				style={{
					'--frameColor': frameColor,
					'--frameColorHilite': frameColorHilite,
					'--frameColorFull': frameColorFull
				}}>
				<CardElement
					options={get_CARD_ELEMENT_OPTIONS(isDark)}
					className={styles.cardElement}
				/>
			</div>
		</fieldset>
	);
};

function CardSection() {
	return (
		<div className={styles.cardSection}>
			<FormControl variant="outlined" color="primary" sx={{ flex: 1 }}>
				<FormLabel htmlFor="zipCode" style={{ margin: '8px 0 8px' }}>
					CARD DETAILS
				</FormLabel>
				<Box sx={{ display: 'flex' }}>
					<CardField />
				</Box>
			</FormControl>
		</div>
	);
}

export default CardSection;
